import {safeHtml} from "../../util/CommonUtils.js";
import {COLUMN_TYPE} from "./TableColumn.js";

export default class EditColumnDialog {
    /** @type {HTMLDialogElement} */
    #dialog;
    constructor() {
        this.#dialog = null;
        this._callbacks = [];
    }

    /**
     * @param {TableColumn} tableColumn
     * @returns {EditColumnDialog}
     */
    render(tableColumn) {
        if (this.#dialog)
            this.#dialog.remove();
        this.#dialog = document.body.insertAdjacentElement("beforeend", this.#createDialog());
        this.#fillColumnTypeOptions(tableColumn)

        let columnName = this.columnName =  this.#dialog.querySelector('#column-name');
        this.expression =  this.#dialog.querySelector('#column-expression');

        if (tableColumn.getDisplayName().length){
            columnName.value = tableColumn.getDisplayName();
            this.expression.value = tableColumn.getExpression()
        }
        columnName.addEventListener('input', ()=>{
            okBtn.toggleAttribute('disabled', !columnName.checkValidity())
        })

        let cancelBtn = this.#dialog.querySelector('.btn-cancel');
        cancelBtn.addEventListener('click', () => {
            this.remove();
        })

        let okBtn = this.#dialog.querySelector('.btn-ok');
        okBtn.addEventListener('click', async () => {
            let inputs = this.#dialog.querySelectorAll('text-input');
            let formValid = true;
            inputs.forEach(input=>{
                if (!input.checkValidity())
                    formValid = false;
            })
            if (!formValid) return;
            this.#dialog.querySelector('.progress').style.display = 'block';
            this.#dialog.querySelectorAll('text-input').forEach(el => {
                el.setDisabled(true);
            });
            this.#dialog.querySelectorAll('button').forEach(el => {
                el.setAttribute('disabled', true);
            });
            let onOk = this._callbacks['ok'];
            if (onOk)
                onOk({name: this.columnName.value, expression:this.expression.value,
                    type: this.#getColumnTypeInput().value.displayName.toLowerCase()});
            else
                this.remove();
        });

        let deleteBtn = this.#dialog.querySelector('.btn-delete');
        if (tableColumn.getDisplayName().length > 0)
            deleteBtn.addEventListener('click', () => {
                let onDelete = this._callbacks['delete'];
                if (onDelete)
                    onDelete(tableColumn)
                else
                    this.remove();
            });
        else
            deleteBtn.style.display = 'none';

        this.#dialog.addEventListener("keydown", (evt) => {
            evt.stopPropagation();
            if (evt.repeat) return;
            switch (evt.key) {
                case 'Enter' : {
                    if (!okBtn.getAttribute('disabled') === true) {
                        okBtn.dispatchEvent(new Event('click'))
                    }
                    break;
                }
                case 'Escape' : {
                    cancelBtn.dispatchEvent(new Event('click'))
                }
            }
        })
        columnName.focus();
        this.#dialog.showModal()
        return this;
    }

    /**
     *
     * @param {"name"|"expression"}field
     * @param {string} message
     */
    showError(field, message){
        this.#dialog.querySelector('.progress').style.display = 'none';
        this.#dialog.querySelectorAll('button').forEach(btn => {
            btn.removeAttribute('disabled');
        });
        this.#dialog.querySelectorAll('text-input').forEach((input) => {
            input.setDisabled(false)
        })
        let input = this.#dialog.querySelector(`#column-${field}`);
        if (input){
            input.errorMessage = message;
            input.focus();
        }
    }

    remove() {
        this.#dialog.remove();
    }

    on(eventName, cb) {
        this._callbacks[eventName] = cb;
    }

    /** @param {TableColumn} tableColumn */
    #fillColumnTypeOptions(tableColumn){
        this.#getColumnTypeInput().options = EditColumnDialog.#COLUMN_TYPE_INPUT_OPTIONS;
        this.#getColumnTypeInput().value = EditColumnDialog.#COLUMN_TYPE_INPUT_OPTIONS.find(o=>
            o.displayName.toLowerCase() === tableColumn.getType()) || EditColumnDialog.#COLUMN_TYPE_INPUT_OPTIONS[0];
    }

    /** @returns {SelectInput} */
    #getColumnTypeInput(){
        return this.#dialog.querySelector('#column-type')
    }

    /** @returns {HTMLDialogElement} */
    #createDialog() {
        const el = document.createElement("dialog");
        el.setAttribute('id', 'edit-column-dialog');
        el.innerHTML = EditColumnDialog.#htmlTemplate();
        return el;
    }

    /** @returns {string} */
    static #htmlTemplate() {
        return safeHtml`
              <div class="progress">
                <div class="indeterminate"></div>
              </div>
              <div class="dialog-content">
                <text-input id="column-name" label="Column name *" minLength="1" maxLength="500" required></text-input>
                <div class="form-row form-row__input-w-icon">
                  <text-input id="column-expression" label="Expression *" required></text-input>
                  <a target="_blank" href="https://elsci.io/docs/peaksel/viz/expressions.html">
                    <i id="input-icon" class="material-symbols-outlined action-icons__item action-icons__item--after-input">help</i>
                  </a>
                </div>
                <select-input id="column-type" label="Column type"></select-input>
              </div>
              <div class="dialog-buttons-row">
                <div class="justify-start"><button class="button button--text button--text-red btn-delete" text="">Delete</button></div>
                <button class="button button--text btn-cancel">Cancel</button>          
                <button class="button button--contained btn-ok">Apply</button>
              </div>
           `
        ;
    }

    static #COLUMN_TYPE_INPUT_OPTIONS = [
        {displayName: COLUMN_TYPE.NUMBERS.toUpperCase()},
        {displayName: COLUMN_TYPE.STRINGS.toUpperCase()},
        {displayName: COLUMN_TYPE.SVG.toUpperCase()},
        {displayName: COLUMN_TYPE.MIXED.toUpperCase()},
    ]
}